<script>
  import { _ } from 'svelte-i18n'
  import { createEventDispatcher } from 'svelte'
  import { user_subscription, modals, can_upgrade_from_pro_to_business } from '../stores'
  import Fieldset from '../elements/Fieldset.svelte'
  import Label from '../elements/Label.svelte'
  import Button from '../elements/Button.svelte'

  $: pro_or_business = $user_subscription?.product?.toLowerCase().includes('business') ? $_('app.businessName') : $_('app.proName')

  const dispatch = createEventDispatcher()

  function openBuy() {
    modals.open('buy')
  }
</script>

  {#if $user_subscription.state !== "deactivated"}
    <Fieldset>
      <Label>{$_('user.subs')} <small>({$user_subscription.state})</small></Label>
      <b class="mb">{$user_subscription.display}</b>
      <Button size="tiny" kind="outline" on:click={() => dispatch('changeSubscription')}>{$_('buttons.changeSubscription')}</Button>
      {#if $can_upgrade_from_pro_to_business}
        <Button size="tiny" kind="outline" on:click={() => dispatch('upgradeToBusiness')}>{$_('buttons.upgradeToBusiness')}</Button>
      {/if}
    </Fieldset>
  {/if}

  <Fieldset>
  <!-- States: active, canceled, deactivated, overdue, trial -->
  {#if $user_subscription.state === "active"}
    <Label>{$_('user.subsNext')}</Label>
    <b>{$user_subscription.nextChargeTotalDisplay} on {$user_subscription.nextDisplay}</b><br>
    {#if !$user_subscription.display.includes('Monthly')}
      <p class="email_notification">
        <small class="mb">{$_('user.subsNotice')}</small>
        <Button size="tiny" kind="outline" on:click={() => dispatch('changePaymentMethod')}>{$_('buttons.changePaymentMethod')}</Button>
      </p>
    {/if}
    Access your invoices, update your payment method or cancel your subscription on your account management page.
  
  {:else if $user_subscription.state === "deactivated"}
    <Label>{$_('user.subs')} <small>({$user_subscription.state})</small></Label>
    <p><b>Your {pro_or_business} subscription is no longer active.</b> Subscribe again to continue using the {pro_or_business} features.</p>
    <p><Button kind="accent-orange" on_fill={true} on:click={openBuy}>{$_('subscriptionPlan.subscribeAgain')}</Button></p>
    <p>You can access your invoices on our account management page.</p>
  
  {:else if $user_subscription.state === "overdue"}
    <p>
      <b class="overdue">We were unable to process the scheduled payment for your subscription.</b>
      We will try again in a couple of days.
    </p>
    <p><Button size="tiny" kind="outline" on:click={() => dispatch('changePaymentMethod')}>{$_('buttons.changePaymentMethod')}</Button></p>
  
  {:else if $user_subscription.state === "canceled"}
    <p>
      <b class="overdue">Your subscription is canceled</b>
      but you can still use your {pro_or_business} account until {$user_subscription.deactivationDateDisplay}
    </p>
    <p>Resume your subscription, update your payment method or access your invoices on your account management page.</p>
  {/if}
</Fieldset>

<style>
  p { 
    margin-bottom: 2rem;
  }
  .overdue {
    color: var(--c-accent-orange);
  }
  p, b {
    font-variant-numeric: lining-nums;
  }
  .mb {
    display: inline-block;
    margin-bottom: 0.25rem;
  }
  @media only screen and (max-height: 508px) {
    .email_notification {
      display: none;
    }
  }
</style>